<template>
    <x-page :title="title">
        <template #header-actions>
            <x-back-button :disabled="isLoading" 
                :display-warning="false" />
        </template>
        <group-statistic-template-form id="group-statistic-template-form"
            v-if="resource"
            :disabled="true"
            :initialFields="resource" />
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import XQuickActionButton from '../../components/XQuickActionButton.vue'
import XQuickEditButton from '../../components/XQuickEditButton.vue'
import { handleGeneralXhrError } from '../../helpers'
import PermissionMixin from '../../mixins/PermissionMixin'
import GroupStatisticTemplateForm from './GroupStatisticTemplateForm.vue'

export default {
    components: {
        XPage,
        XBackButton,
        GroupStatisticTemplateForm,
        XQuickActionButton,
        XQuickEditButton,
    },
    created() {
        this.fetchResource()
    },
    computed: {
        title() {
            return [
                _.get(this.resource, 'name', null),
                'Template Statistik',
            ].filter(segment => Boolean(segment)).join(' | ')
        }
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        }
    },
    methods: {
        fetchResource() {
            this.isLoading = true
            const request = axios.get(`/api/group-statistic-templates/${this.$route.params.id}`)
            .then(response => {
                const resources = response.data.data
                this.resource = { ...resources }
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
    },
    mixins: [
        PermissionMixin,
    ],
}
</script>